// Dropdown options for the Settings page timezone picker. Keep in sync with
// server/src/config/timezones.js (allow-list) and the abbreviation map in
// utcClock.js. The `value` is an IANA zone identifier — the server validates
// against the same list before writing. The `label` is what the user sees.

export const TIMEZONE_OPTIONS = [
  { value: 'UTC',                 label: 'UTC — Coordinated Universal Time' },
  { value: 'Europe/London',       label: 'Europe/London (GMT/BST)' },
  { value: 'Europe/Paris',        label: 'Europe/Paris (CET/CEST)' },
  { value: 'Europe/Berlin',       label: 'Europe/Berlin (CET/CEST)' },
  { value: 'Europe/Kyiv',         label: 'Europe/Kyiv (EET/EEST)' },
  { value: 'Europe/Moscow',       label: 'Europe/Moscow (MSK)' },
  { value: 'Europe/Istanbul',     label: 'Europe/Istanbul (TRT)' },
  { value: 'Europe/Athens',       label: 'Europe/Athens (EET/EEST)' },
  { value: 'Europe/Bucharest',    label: 'Europe/Bucharest (EET/EEST)' },
  { value: 'Europe/Warsaw',       label: 'Europe/Warsaw (CET/CEST)' },
  { value: 'Europe/Helsinki',     label: 'Europe/Helsinki (EET/EEST)' },
  { value: 'Asia/Tbilisi',        label: 'Asia/Tbilisi (GET)' },
  { value: 'Asia/Baku',           label: 'Asia/Baku (AZT)' },
  { value: 'Asia/Dubai',          label: 'Asia/Dubai (GST)' },
  { value: 'Asia/Kolkata',        label: 'Asia/Kolkata (IST)' },
  { value: 'Asia/Shanghai',       label: 'Asia/Shanghai (CST)' },
  { value: 'Asia/Tokyo',          label: 'Asia/Tokyo (JST)' },
  { value: 'America/New_York',    label: 'America/New_York (EST/EDT)' },
  { value: 'America/Chicago',     label: 'America/Chicago (CST/CDT)' },
  { value: 'America/Denver',      label: 'America/Denver (MST/MDT)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles (PST/PDT)' }
];

export const TIMEZONE_VALUES = new Set(TIMEZONE_OPTIONS.map((o) => o.value));

export const DEFAULT_TIMEZONE = 'UTC';
